var map = {
  "./500": "4234",
  "./500.png": "4234",
  "./email": "13559",
  "./email.png": "13559",
  "./researcher_shrugging": "28636",
  "./researcher_shrugging.png": "28636",
  "./ui-logo-icon-navy-bg": "94064",
  "./ui-logo-icon-navy-bg.png": "94064"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = function() { return Object.keys(map); };
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 86190;
